import { StateHandlerBase } from './state.handler.base';

export class EnabledStateHandler extends StateHandlerBase {
  public override handle(): void {
    const isEnabled: boolean = this.evaluator.evaluate();

    this.element.attributes = {
      ...this.element.attributes,
      disabled: !isEnabled,
    };

    if (!this.control) {
      return;
    }

    if (isEnabled) {
      this.control.enable();
      this.control.markAsUntouched();
    } else {
      this.control.reset();
      this.control.disable();
    }
  }
}
